import { Album, AlbumStatus, AnyAlbumEntityVersion } from '@uploadcam/common';
import { GetAlbumByIdInteractor } from './get-album-by-id.interactor';
import { CollectionReference, doc, setDoc } from 'firebase/firestore';

interface UpdateAlbumData {
  systemStatus?: AlbumStatus;
}

export class UpdateAlbumDataInteractor {
  constructor(
    private readonly collection: CollectionReference<AnyAlbumEntityVersion>,
    private readonly getAlbumById: GetAlbumByIdInteractor,
  ) {}

  public async execute(albumId: string, data: UpdateAlbumData): Promise<Album> {
    await setDoc(doc(this.collection, albumId), data, { merge: true });

    return this.getAlbumById.execute(albumId);
  }
}
